import React, { useState, useEffect } from 'react';
import Modal from '../Modal';
import { formatCOP } from './clientesHelpers';
import { s } from './clientesEstilos';
import ElegirUbicacion from '../comunes/ElegirUbicacion';
import { caminoDe, planesDe, ORIGENES, admiteEmpresarial } from './caminoCliente';
import FotosCliente from './FotosCliente';

export default function ClienteFormModal({
  abierto, onCerrar, editando, form, f, error, guardando, guardar,
  planes, proveedoresRed, perfilesPPPoE, ipsDisponibles, cargandoIPs, cargarIPs, obtenerUbicacion,
  capturandoGPS, precisionGPS,
}) {
  // Señalar la casa del cliente en el mapa, sin tener que ir hasta allá con el celular
  const [enMapa, setEnMapa] = useState(false);

  /**
   * Lo que hace falta para ESTE cliente, deducido de cómo le llega el servicio.
   * Las reglas están en caminoCliente.js, escritas una sola vez.
   */
  const camino = caminoDe(form);

  /**
   * El tipo de conexión en el MikroTik ya no se elige a mano: sale del camino.
   *
   * Era el error más fácil de cometer y el más caro: marcar PPPoE en un cliente de radio lo
   * deja instalado y sin servicio, y ponerle cuenta a un cliente de proveedor hace que el
   * sistema crea que ese servicio lo prestamos nosotros.
   */
  const tipoMk = camino.mikrotikTipo;
  useEffect(() => {
    if (!abierto) return;

    // Si el tipo guardado no es el que toca, se corrige y se limpia lo que ya no aplica
    if (form.mikrotik_tipo !== tipoMk) {
      f('mikrotik_tipo', tipoMk);
      if (tipoMk === 'ninguno') { f('mikrotik_usuario', ''); f('mikrotik_perfil', ''); f('ip_cliente', ''); }
    }

    /**
     * Las IPs se piden SIEMPRE al abrir, no solo cuando el tipo cambia.
     *
     * Cada tipo usa su propio rango —la fibra va por 10.16.16.x y el radio por
     * 172.100.x— y son listas distintas. Pidiéndolas solo al cambiar, al abrir un cliente
     * de radio cuyo tipo ya venía bien no se pedía nada y quedaba en pantalla la lista del
     * cliente anterior: a un cliente de radio se le ofrecían IPs de fibra.
     */
    if (tipoMk !== 'ninguno') cargarIPs(tipoMk);
  }, [tipoMk, abierto]);

  // La tecnología también se deduce: proveedor y revendedor son siempre fibra
  useEffect(() => {
    if (!abierto || !camino.tecnologia) return;
    if (form.tecnologia_instalada !== camino.tecnologia) f('tecnologia_instalada', camino.tecnologia);
  }, [camino.tecnologia, abierto]);

  const planesUtiles = planesDe(planes, camino.tecnologia);
  const revendedor = (form._revendedores || []).find(r => r.id === form.revendedor_id);

  /**
   * Las IPs que se pueden elegir, con la que el cliente YA tiene de primera.
   *
   * El router devuelve solo las libres, y la de un cliente que ya está instalado no lo
   * está: por eso, al editar, su propia IP no salía en la lista y había que acordarse de
   * ella o ir a buscarla al MikroTik. Se pone arriba, marcada como la actual.
   */
  const suIp = form.ip_cliente || '';

  /**
   * Y del rango que corresponde, no de cualquiera.
   *
   * La fibra vive en 10.16.16.x y el radio en 172.100.x. Se filtra aquí además de pedir la
   * lista correcta, para que un desfase entre lo que muestra la pantalla y lo que ya
   * respondió el router no llegue nunca a ofrecer una IP imposible. La suya se respeta
   * siempre, aunque no encaje: es la que tiene puesta de verdad.
   */
  const delRango = (ip) => tipoMk === 'pppoe' ? ip.startsWith('10.16.16.')
                         : tipoMk === 'simple_queue' ? ip.startsWith('172.100.')
                         : true;
  const libres = ipsDisponibles.filter(delRango);
  const ipsParaElegir = suIp && !libres.includes(suIp) ? [suIp, ...libres] : libres;
  const etiquetaIp = (ip) => ip === suIp && editando ? `${ip} — la que tiene ahora` : ip;

  return (
    <Modal abierto={abierto} onCerrar={onCerrar}
      titulo={editando ? 'Editar Cliente' : 'Nuevo Cliente'} ancho="1000px">
      <div style={s.formGrid}>
        {/* ══════ SECCIÓN 1: DATOS DEL CLIENTE ══════ */}
        <div style={{ gridColumn:'1/-1', fontSize:'11px', fontWeight:'700', color:'rgba(255,255,255,0.35)', textTransform:'uppercase', letterSpacing:'1px', paddingBottom:'2px', borderBottom:'1px solid rgba(255,255,255,0.07)' }}>👤 Datos del cliente</div>
        <div style={{ ...s.campo, gridColumn:'1/-1' }}>
          <label style={s.label}>Nombre completo *</label>
          <input style={s.input} value={form.nombre} onChange={e => f('nombre', e.target.value)} placeholder="Nombre del cliente" />
        </div>
        <div style={s.campo}>
          <label style={s.label}>Cédula</label>
          <input style={s.input} value={form.cedula} onChange={e => f('cedula', e.target.value)} placeholder="Número de cédula" />
        </div>
        <div style={s.campo}>
          <label style={s.label}>Teléfono</label>
          <input style={s.input} value={form.telefono} onChange={e => f('telefono', e.target.value)} placeholder="Número de contacto" />
        </div>
        <div style={s.campo}>
          <label style={s.label}>Correo electrónico</label>
          <input style={s.input} type="email" value={form.email} onChange={e => f('email', e.target.value)} placeholder="correo@ejemplo.com" />
        </div>
        {/* De un revendedor no cuelgan empresas: sus clientes son siempre residenciales, así
            que no se pregunta. Un desplegable con una sola respuesta posible es una
            pregunta de más y una ocasión de equivocarse. */}
        {!admiteEmpresarial(form._origen) ? (
          <div style={s.campo}>
            <label style={s.label}>Tipo de cliente</label>
            <div style={{ ...s.input, display:'flex', alignItems:'center',
                          color:'rgba(255,255,255,0.55)' }}>
              🏠 Residencial — los clientes de un revendedor siempre lo son
            </div>
          </div>
        ) : (
        <div style={s.campo}>
          <label style={s.label}>Tipo de cliente</label>
          <select style={s.input} value={form.tipo_cliente} onChange={e => f('tipo_cliente', e.target.value)}>
            <option value="residencial">🏠 Residencial — lleva plan</option>
            <option value="empresarial">💼 Empresarial — velocidad y valor acordados</option>
            {/* «Revendedor» ya no se ofrece como clase de cliente: eso se dice arriba, en
                de quién es la red. Se conserva si un cliente viejo lo tiene, para no
                cambiarle el tipo sin querer al editarlo por otra cosa. */}
            {form.tipo_cliente === 'revendedor' && (
              <option value="revendedor">🏢 Revendedor / Mayorista (tipo antiguo)</option>
            )}
          </select>
        </div>
        )}
        <div style={{ ...s.campo, gridColumn: '1/-1' }}>
          <label style={s.label}>Dirección</label>
          <input style={s.input} value={form.direccion} onChange={e => f('direccion', e.target.value)} placeholder="Dirección de instalación" />
        </div>

        {/* ══════ SECCIÓN 2: POR DÓNDE LE LLEGA ══════
            Tres preguntas en orden. De ellas sale el resto del formulario: qué se le crea
            en el router, si lleva plan o contrato, y qué datos hacen falta. */}
        <div style={{ gridColumn:'1/-1', fontSize:'11px', fontWeight:'700', color:'rgba(255,255,255,0.35)', textTransform:'uppercase', letterSpacing:'1px', paddingBottom:'2px', borderBottom:'1px solid rgba(255,255,255,0.07)', marginTop:'6px' }}>🌐 Por dónde le llega</div>

        {/* 1. Radio o fibra */}
        <div style={{ gridColumn:'1/-1' }}>
          <label style={s.label}>¿Cómo le llega el servicio? *</label>
          <div style={{ display:'flex', gap:'8px', flexWrap:'wrap', marginTop:'4px' }}>
            {[{ id:'radio_enlace', icono:'📡', texto:'Por radio' },
              { id:'fibra',        icono:'🔵', texto:'Por fibra' }].map(t => (
              <button key={t.id} type="button" style={pastilla(camino.tecnologia === t.id)}
                onClick={() => {
                  f('tecnologia_instalada', t.id);
                  // El radio siempre es red propia: no hay proveedor ni revendedor de radio
                  if (t.id === 'radio_enlace') { f('_origen','propia'); f('revendedor_id',''); f('proveedor_red_id',''); }
                }}>
                {t.icono} {t.texto}
              </button>
            ))}
          </div>
        </div>

        {/* 2. De quién es la red. Solo para fibra: el radio siempre es nuestro */}
        {camino.tecnologia === 'fibra' && (
          <div style={{ gridColumn:'1/-1' }}>
            <label style={s.label}>¿De quién es la red? *</label>
            <div style={{ display:'flex', gap:'8px', flexWrap:'wrap', marginTop:'4px' }}>
              {Object.entries(ORIGENES).map(([id, o]) => (
                <button key={id} type="button" style={pastilla((form._origen||'propia') === id)}
                  onClick={() => {
                    f('_origen', id);
                    if (id !== 'revendedor') f('revendedor_id', '');
                    if (id !== 'proveedor') f('proveedor_red_id', '');
                    // De un revendedor no cuelgan empresas: si venía marcado, se corrige
                    if (!admiteEmpresarial(id) && form.tipo_cliente === 'empresarial') {
                      f('tipo_cliente', 'residencial');
                    }
                  }}>
                  {o.icono} {o.texto}
                </button>
              ))}
            </div>
          </div>
        )}
        {form.tecnologia_instalada === 'radio_enlace' && (
          <div style={{ gridColumn:'1/-1', fontSize:'11.5px', color:'rgba(255,255,255,0.4)', marginTop:'-6px' }}>
            El radio siempre va por tu propia red.
          </div>
        )}

        {/* Lo que se deduce, dicho en palabras, para poder corregir antes de guardar */}
        {camino.tecnologia && (
          <div style={{ gridColumn:'1/-1', fontSize:'12.5px', lineHeight:1.55,
            background: camino.enNuestroRouter ? 'rgba(0,229,255,0.06)' : 'rgba(251,191,36,0.07)',
            border: `1px solid ${camino.enNuestroRouter ? 'rgba(0,229,255,0.22)' : 'rgba(251,191,36,0.25)'}`,
            borderRadius:'10px', padding:'10px 12px',
            color: camino.enNuestroRouter ? '#7DD3FC' : '#FDE047' }}>
            {camino.enNuestroRouter ? '→ ' : '⚠ '}{camino.explicacion}
          </div>
        )}
        {form._origen === 'revendedor' && (
          <div style={{ ...s.campo, gridColumn:'1/-1' }}>
            <label style={s.label}>Revendedor *</label>
            <select style={s.input} value={form.revendedor_id||''} onChange={e => f('revendedor_id', e.target.value)}>
              <option value="">— Seleccionar revendedor —</option>
              {(form._revendedores||[]).map(r => (
                <option key={r.id} value={r.id}>{r.nombre} ({formatCOP(r.tarifa_por_cliente)}/mes)</option>
              ))}
            </select>
          </div>
        )}
        {form._origen === 'proveedor' && (
          <>
            <div style={{ ...s.campo, gridColumn:'1/-1' }}>
              <label style={s.label}>Proveedor de red *</label>
              <select style={s.input} value={form.proveedor_red_id} onChange={e => f('proveedor_red_id', e.target.value)}>
                <option value="">— Seleccionar proveedor —</option>
                {proveedoresRed.map(p => (
                  <option key={p.id} value={p.id}>{p.nombre} — {formatCOP(p.tarifa_por_cliente)}/mes</option>
                ))}
              </select>
              {form.proveedor_red_id && (
                <div style={s.proveedorHint}>
                  ⚠ El costo mensual de este cliente se sumará a tu deuda con el proveedor seleccionado.
                </div>
              )}
            </div>

            {/* Los datos que entrega el proveedor. NO son de nuestro router: sirven para
                configurar el equipo en casa del cliente. */}
            <div style={{ ...s.campo, gridColumn:'1/-1', background:'rgba(251,191,36,0.05)',
              border:'1px solid rgba(251,191,36,0.2)', borderRadius:'10px', padding:'14px' }}>
              <label style={{ ...s.label, color:'#FDE047', fontWeight:'600' }}>
                🔑 Datos que entrega el proveedor
              </label>
              <div style={{ fontSize:'11.5px', color:'rgba(255,255,255,0.45)', margin:'2px 0 10px' }}>
                Para configurar el equipo del cliente. Esta cuenta es del proveedor: no se
                crea ni se suspende desde aquí.
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' }}>
                <div style={s.campo}>
                  <label style={s.label}>Usuario PPPoE del proveedor</label>
                  <input style={s.input} value={form.proveedor_pppoe_usuario || ''}
                    onChange={e => f('proveedor_pppoe_usuario', e.target.value)} placeholder="El que le dio el proveedor" />
                </div>
                <div style={s.campo}>
                  <label style={s.label}>Contraseña PPPoE</label>
                  <input style={s.input} value={form.proveedor_pppoe_password || ''}
                    onChange={e => f('proveedor_pppoe_password', e.target.value)} placeholder="La del proveedor" />
                </div>
                <div style={s.campo}>
                  <label style={s.label}>VLAN</label>
                  <input style={s.input} value={form.proveedor_vlan || ''}
                    onChange={e => f('proveedor_vlan', e.target.value)} placeholder="Ej: 100" />
                </div>
              </div>
              <div style={{ fontSize:'11.5px', color:'rgba(255,255,255,0.45)', marginTop:'10px' }}>
                📷 Las fotos de la instalación se suben en la ficha del cliente, una vez creado.
              </div>
            </div>
          </>
        )}

        {/* ══════ SECCIÓN 3: SERVICIO ══════ */}
        <div style={{ gridColumn:'1/-1', fontSize:'11px', fontWeight:'700', color:'rgba(255,255,255,0.35)', textTransform:'uppercase', letterSpacing:'1px', paddingBottom:'2px', borderBottom:'1px solid rgba(255,255,255,0.07)', marginTop:'6px' }}>📋 Servicio</div>
        {/* Un cliente empresarial no lleva plan de catálogo: lleva lo que se acordó.
            Mostrar los dos a la vez fue lo que dejó clientes con plan Y precio especial,
            sin que se supiera cuál manda. */}
        {camino.cobro !== 'contrato' && (
          <div style={s.campo}>
            <label style={s.label}>
              Plan{camino.tecnologia ? ` de ${camino.tecnologia === 'fibra' ? 'fibra' : 'radio'}` : ''}
            </label>
            <select style={s.input} value={form.plan_id} onChange={e => f('plan_id', e.target.value)}>
              <option value="">Sin plan</option>
              {planesUtiles.map(p => (
                <option key={p.id} value={p.id}>
                  {p.nombre}{p.velocidad_bajada ? ` · ${p.velocidad_bajada}/${p.velocidad_subida || p.velocidad_bajada} Mbps` : ''} · {formatCOP(p.precio_mensual)}/mes
                </option>
              ))}
            </select>
            {camino.tecnologia && planesUtiles.length === 0 && (
              <div style={{ fontSize:'11.5px', color:'#FDBA74', marginTop:'4px' }}>
                No hay planes para {camino.tecnologia === 'fibra' ? 'fibra' : 'radio'}. Créalos en Planes.
              </div>
            )}
          </div>
        )}

        {/* Lo acordado con la empresa: reemplaza al plan */}
        {camino.cobro === 'contrato' && (
          <>
            <div style={s.campo}>
              <label style={s.label}>Velocidad acordada</label>
              <input style={s.input} value={form.velocidad_contratada || ''}
                onChange={e => f('velocidad_contratada', e.target.value)} placeholder="Ej: 50/25 Mbps" />
            </div>
            <div style={s.campo}>
              <label style={s.label}>Valor mensual acordado (COP) *</label>
              <input style={s.input} type="number" value={form.precio_especial}
                onChange={e => f('precio_especial', e.target.value)} placeholder="Lo que se le cobra al mes" />
            </div>
          </>
        )}

        <div style={s.campo}>
          <label style={s.label}>Día de pago mensual</label>
          <select style={s.input} value={form.dia_pago} onChange={e => f('dia_pago', e.target.value)}>
            {[1,5,10,15,20,25,28].map(d => <option key={d} value={d}>Día {d}</option>)}
          </select>
        </div>

        {/* Lo acordado con el revendedor manda sobre el precio del plan */}
        {camino.cobro === 'revendedor' && (
          <div style={s.campo}>
            <label style={s.label}>Valor mensual acordado con el revendedor (COP)</label>
            <input style={s.input} type="number" value={form.precio_especial}
              onChange={e => f('precio_especial', e.target.value)}
              placeholder={revendedor?.tarifa_por_cliente
                ? `Vacío = ${formatCOP(revendedor.tarifa_por_cliente)} de su tarifa` : 'Vacío = el precio del plan'} />
            <div style={{ fontSize:'11.5px', color:'rgba(255,255,255,0.45)', marginTop:'4px' }}>
              Si lo dejas vacío se cobra {revendedor?.tarifa_por_cliente
                ? `la tarifa del revendedor (${formatCOP(revendedor.tarifa_por_cliente)})` : 'el precio del plan'}.
            </div>
          </div>
        )}
        {editando && (
          <div style={s.campo}>
            <label style={s.label}>Estado</label>
            <select style={s.input} value={form.estado} onChange={e => f('estado', e.target.value)}>
              <option value="activo">Activo</option>
              <option value="moroso">Moroso</option>
              <option value="suspendido">Suspendido</option>
              <option value="inactivo_temporal">⏸ Inactivo temporal (sin contrato actual)</option>
              <option value="retirado">Retirado</option>
            </select>
          </div>
        )}
        <div style={{ ...s.campo, gridColumn: '1/-1' }}>
          <label style={s.label}>Notas</label>
          <textarea style={{ ...s.input, resize: 'vertical', minHeight: '60px' }} value={form.notas} onChange={e => f('notas', e.target.value)} placeholder="Observaciones adicionales" />
        </div>
        {/* El precio especial ya se pide arriba cuando corresponde —en el contrato de una
            empresa o en lo acordado con el revendedor—. Aquí solo queda para los casos
            sueltos: un descuento a un cliente residencial de red propia. */}
        {camino.cobro === 'plan' && (
          <>
            <div style={s.campo}>
              <label style={s.label}>Precio especial (COP)</label>
              <input style={s.input} type="number" value={form.precio_especial} onChange={e => f('precio_especial', e.target.value)} placeholder="Solo si difiere del plan" />
            </div>
            <div style={s.campo}>
              <label style={s.label}>Motivo precio especial</label>
              <input style={s.input} value={form.motivo_precio_especial} onChange={e => f('motivo_precio_especial', e.target.value)} placeholder="Ej: Dueño del lote de la torre" />
            </div>
          </>
        )}
        {/* A este no se le cobra: los de contraprestación, los que llevan «CR» en el
            MikroTik. La columna existía y se leía en la lista, en el filtro y en el
            Dashboard, pero no había dónde marcarla — así que no se podía crear ninguno.

            Va en ancho completo y no al lado del precio a propósito: es lo contrario de un
            precio, y ponerlos juntos invita a llenar los dos. */}
        <div style={{ ...s.campo, gridColumn: '1/-1' }}>
          <label style={{ display:'flex', alignItems:'center', gap:'8px', cursor:'pointer', color:'rgba(255,255,255,0.85)', fontSize:'13px' }}>
            <input type="checkbox" checked={form.contraprestacion === true}
              onChange={e => f('contraprestacion', e.target.checked)} />
            🎁 A este cliente <b>no se le cobra</b> (contraprestación)
          </label>
          {form.contraprestacion === true && (
            <input style={{ ...s.input, marginTop:'8px' }} value={form.motivo_contraprestacion || ''}
              onChange={e => f('motivo_contraprestacion', e.target.value)}
              placeholder="Por qué no se le cobra — ej: dueño del lote de la torre" />
          )}
        </div>
        <div style={s.campo}>
          <label style={s.label}>📅 Fecha de instalación</label>
          <input style={s.input} type="date" value={form.fecha_instalacion} onChange={e => f('fecha_instalacion', e.target.value)} />
        </div>
        <div style={s.campo}>
          <label style={s.label}>Notas de instalación</label>
          <input style={s.input} value={form.observaciones_instalacion} onChange={e => f('observaciones_instalacion', e.target.value)} placeholder="Ej: Casa esquina, segundo piso" />
        </div>

        {/* Las fotos de la instalación: se suben y se borran aquí, no en Detalle, que es
            la pantalla de mirar. En un cliente nuevo se guardan y se suben al crearlo. */}
        <FotosCliente clienteId={editando?.id}
          pendientes={form._fotosPendientes}
          alCambiarPendientes={(v) => f('_fotosPendientes', v)} />

        {/* Sección GPS */}
        <div style={{ ...s.campo, gridColumn:'1/-1', background:'rgba(16,185,129,0.04)', border:'1px solid rgba(16,185,129,0.12)', borderRadius:'10px', padding:'14px' }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'10px' }}>
            <label style={{ ...s.label, color:'#10B981', fontWeight:'600' }}>📍 Ubicación GPS</label>
            <div style={{ display:'flex', gap:'6px', flexWrap:'wrap' }}>
              {/* Desde el computador no hay GPS útil: se señala el punto en el mapa */}
              <button type="button" onClick={() => setEnMapa(true)}
                style={{ background:'rgba(99,102,241,0.15)', border:'1px solid rgba(99,102,241,0.35)', borderRadius:'8px', padding:'6px 12px', color:'#A5B4FC', fontSize:'12px', cursor:'pointer' }}>
                🗺️ Señalar en el mapa
              </button>
              <button type="button" disabled={capturandoGPS}
                style={{ background:'rgba(16,185,129,0.15)', border:'1px solid rgba(16,185,129,0.3)', borderRadius:'8px', padding:'6px 12px', color:'#6EE7B7', fontSize:'12px', cursor: capturandoGPS ? 'wait' : 'pointer', opacity: capturandoGPS ? 0.6 : 1 }}
                onClick={obtenerUbicacion}>
                {capturandoGPS ? '📡 Buscando señal…' : '📡 Estoy en el sitio'}
              </button>
            </div>
          </div>
          {form.ubicacion_origen === 'mapa' && form.latitud && (
            <div style={{ fontSize:'11.5px', color:'#FDBA74', marginBottom:'8px' }}>
              Punto señalado en el mapa: es aproximado. Cuando alguien vaya al sitio puede
              corregirlo con "Estoy en el sitio".
            </div>
          )}
          {capturandoGPS && (
            <div style={{ fontSize:'11.5px', color:'#6EE7B7', marginBottom:'8px' }}>
              Buscando la ubicación… puede tardar unos segundos. No cierres esta ventana.
            </div>
          )}
          {precisionGPS != null && !capturandoGPS && (
            <div style={{ fontSize:'11.5px', color: precisionGPS <= 30 ? '#6EE7B7' : '#FBBF24', marginBottom:'8px' }}>
              Precisión aproximada: {precisionGPS} m{precisionGPS > 100 ? ' — poco exacta, intenta al aire libre' : ''}
            </div>
          )}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'12px' }}>
            <div style={s.campo}>
              <label style={s.label}>Latitud</label>
              <input style={s.input} value={form.latitud} onChange={e => f('latitud', e.target.value)} placeholder="Ej: 1.2136" />
            </div>
            <div style={s.campo}>
              <label style={s.label}>Longitud</label>
              <input style={s.input} value={form.longitud} onChange={e => f('longitud', e.target.value)} placeholder="Ej: -77.2811" />
            </div>
          </div>
          <div style={{ ...s.campo, marginTop:'10px' }}>
            <label style={s.label}>Enlace o referencia de Google Maps (opcional)</label>
            <input style={s.input} value={form.direccion_maps || ''} onChange={e => f('direccion_maps', e.target.value)}
              placeholder="Pega aquí el enlace de Maps o una referencia del sitio" />
          </div>
          {form.latitud && form.longitud && (
            <a href={`https://www.google.com/maps?q=${form.latitud},${form.longitud}`} target="_blank" rel="noopener noreferrer" style={{ display:'inline-block', marginTop:'8px', fontSize:'12px', color:'#10B981', textDecoration:'none' }}>
              🗺 Ver en Google Maps
            </a>
          )}
        </div>

        {/* Sección MikroTik. Solo aparece si a este cliente se le crea algo en el router:
            para uno de proveedor no hay nada que configurar aquí. */}
        {camino.enNuestroRouter && (
        <div style={{ ...s.campo, gridColumn:'1/-1', background:'rgba(0,229,255,0.04)', border:'1px solid rgba(0,229,255,0.12)', borderRadius:'10px', padding:'14px' }}>
          <label style={{ ...s.label, color:'#00E5FF', fontWeight:'600', marginBottom:'4px' }}>
            📡 En tu MikroTik: {tipoMk === 'pppoe' ? 'PPPoE' : 'cola simple'}
          </label>
          {/* El tipo ya no se elige: sale de cómo le llega el servicio. Elegirlo a mano era
              el error más fácil y más caro —PPPoE en un cliente de radio lo deja instalado
              y sin internet—. */}
          <div style={{ fontSize:'11.5px', color:'rgba(255,255,255,0.45)', marginBottom:'10px' }}>
            Se decide solo por cómo le llega el servicio. Si no es lo que esperabas, corrige
            arriba «Por dónde le llega».
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(210px, 1fr))', gap:'12px' }}>

            {/* PPPoE */}
            {form.mikrotik_tipo === 'pppoe' && (
              <>
                <div style={s.campo}>
                  <label style={s.label}>Usuario PPPoE</label>
                  <input style={s.input} value={form.mikrotik_usuario} onChange={e => f('mikrotik_usuario', e.target.value)} placeholder="Ej: juanperez" />
                </div>
                <div style={s.campo}>
                  <label style={s.label}>Contraseña PPPoE {!editando && <span style={{ color:'#F59E0B', fontSize:'11px' }}>← Se creará en MikroTik</span>}</label>
                  <input style={s.input} type="text" value={form.mikrotik_password} onChange={e => f('mikrotik_password', e.target.value)} placeholder={editando ? 'Vacío = no cambiar' : 'Contraseña del cliente'} />
                </div>
                <div style={s.campo}>
                  <label style={s.label}>Perfil PPPoE (velocidad)</label>
                  {perfilesPPPoE.length > 0 ? (
                    <select style={s.input} value={form.mikrotik_perfil} onChange={e => f('mikrotik_perfil', e.target.value)}>
                      <option value="">Seleccionar perfil...</option>
                      {perfilesPPPoE.map(p => (
                        <option key={p.nombre} value={p.nombre}>{p.nombre}{p.velocidad ? ` — ${p.velocidad}` : ''}</option>
                      ))}
                    </select>
                  ) : (
                    <input style={s.input} value={form.mikrotik_perfil} onChange={e => f('mikrotik_perfil', e.target.value)} placeholder="Ej: 100megas" />
                  )}
                </div>
                <div style={s.campo}>
                  <label style={s.label}>IP fija (red 10.16.16.x) {cargandoIPs && <span style={{ color:'#F59E0B', fontSize:'11px' }}>cargando...</span>}</label>
                  {ipsParaElegir.length > 0 ? (
                    <select style={s.input} value={form.ip_cliente || ''} onChange={e => f('ip_cliente', e.target.value)}>
                      <option value="">Seleccionar IP disponible...</option>
                      {ipsParaElegir.slice(0, 50).map(ip => (
                        <option key={ip} value={ip}>{etiquetaIp(ip)}</option>
                      ))}
                    </select>
                  ) : (
                    <input style={s.input} value={form.ip_cliente || ''} onChange={e => f('ip_cliente', e.target.value)} placeholder="Ej: 10.16.16.50" />
                  )}
                </div>
              </>
            )}

            {/* Simple Queue */}
            {form.mikrotik_tipo === 'simple_queue' && (
              <>
                <div style={s.campo}>
                  <label style={s.label}>Nombre de la cola</label>
                  <input style={s.input} value={form.mikrotik_usuario} onChange={e => f('mikrotik_usuario', e.target.value)} placeholder="Ej: JUAN PEREZ" />
                </div>
                <div style={s.campo}>
                  <label style={s.label}>Velocidad (bajada/subida)</label>
                  <input style={s.input} value={form.mikrotik_perfil} onChange={e => f('mikrotik_perfil', e.target.value)} placeholder="Ej: 10M/5M" />
                </div>
                <div style={{ ...s.campo, gridColumn:'1/-1' }}>
                  <label style={s.label}>IP del cliente (red 172.100.0.x / 172.100.1.x) {cargandoIPs && <span style={{ color:'#F59E0B', fontSize:'11px' }}>cargando...</span>} <span style={{ color:'#F59E0B', fontSize:'11px' }}>← Se creará la cola en MikroTik</span></label>
                  {ipsParaElegir.length > 0 ? (
                    <select style={s.input} value={form.ip_cliente || ''} onChange={e => f('ip_cliente', e.target.value)}>
                      <option value="">Seleccionar IP disponible...</option>
                      {ipsParaElegir.slice(0, 600).map(ip => (
                        <option key={ip} value={ip}>{etiquetaIp(ip)}</option>
                      ))}
                    </select>
                  ) : (
                    <input style={s.input} value={form.ip_cliente || ''} onChange={e => f('ip_cliente', e.target.value)} placeholder="Ej: 172.100.0.50" />
                  )}
                </div>
              </>
            )}
          </div>
        </div>
        )}
      </div>
      {error && <div style={s.error}>{error}</div>}
      <div style={s.modalFooter}>
        <button style={s.btnSec} onClick={onCerrar}>Cancelar</button>
        <button style={s.btnPrimario} onClick={guardar} disabled={guardando}>{guardando ? 'Guardando...' : 'Guardar Cliente'}</button>
      </div>

      {enMapa && (
        <ElegirUbicacion
          inicial={form} nombre={form.nombre || 'este cliente'}
          alElegir={(p) => {
            f('latitud', p.latitud); f('longitud', p.longitud);
            f('ubicacion_origen', p.ubicacion_origen);
          }}
          alCerrar={() => setEnMapa(false)} />
      )}
    </Modal>
  );
}

// Los botones de elegir, que se ven encendidos cuando están escogidos
const pastilla = (activa) => ({
  flex: '1 1 150px', padding: '11px 8px', borderRadius: '10px', cursor: 'pointer',
  fontSize: '13px', fontWeight: '600',
  background: activa ? 'rgba(0,229,255,0.12)' : 'rgba(255,255,255,0.04)',
  border: activa ? '1px solid rgba(0,229,255,0.4)' : '1px solid rgba(255,255,255,0.1)',
  color: activa ? '#00E5FF' : 'rgba(255,255,255,0.55)',
});
